import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  backIcon as homeIcon,
  undoActiveIcon as undoIcon,
  redoInactiveIcon as redoIcon,
  downloadPngIcon as downloadIcon,
} from "../../icons/assets";
import "./BatchEditorHeader.css";

const BatchEditorHeader = () => {
  const [showDownloadOptions, setShowDownloadOptions] = useState(false);
  const navigate = useNavigate();

  const handleDownloadClick = () => {
    setShowDownloadOptions(true);
  };

  const handleHomeClick = () => {
    navigate("/dashboard");
  };

  return (
    <div className="batch-editor-header">
      <div className="batch-header__left-section">
        <button className="batch-header__home-icon-btn" title="Home" onClick={handleHomeClick}>
          <img className="batch-header__home-icon" src={homeIcon} alt="Home" />
        </button>
        <button className="batch-header__icon-btn" title="Undo">
          <img className="batch-header__icon" src={undoIcon} alt="Undo" />
        </button>
        <button className="batch-header__icon-btn" title="Redo">
          <img className="batch-header__icon" src={redoIcon} alt="Redo" />
        </button>
      </div>
      <div className="batch-header__right-section">
        <button className="batch-header__download-btn" onClick={handleDownloadClick}>
          <img src={downloadIcon} alt="Download" className="batch-header__icon" />
          Download
        </button>
      </div>
      {/* Download options modal can be added here if needed */}
    </div>
  );
};

export default BatchEditorHeader;
